import { createFileRoute, Navigate } from '@tanstack/react-router';

/** Legacy alias: CRM → clients list */
export const Route = createFileRoute('/manager/crm')({
  component: () => <Navigate to="/manager/clients" replace />,
});
